module.exports = {"TXTCLI_Invalid_date":{"id":"TXTCLI_Invalid_date","defaultMessage":"Ungültiges Datum","track":"Invalid date"}}